module.exports = __webpack_public_path__ + "static/img/password.0ba97770.png";